import { OutgoingCheck } from './outgoing-check';
import { OutgoingDocument } from './outgoing-document';
import { OutgoingDocumentFax } from './outgoing-document-fax';
import { OutgoingEnvelope } from './outgoing-envelope';
import { OutgoingLabel } from './outgoing-label';

export class OutgoingJob {
  id: number;
  intranet_id: number;
  matter_id: number;
  status: string;
  instructions: string;
  checked_out_by: number;
  checked_out_at: string;
  sent_at: string;
  created_at: string;
  updated_at: string;
  created_by: number;
  updated_by: string;
  matter_history_id: number;
  auto_outgoing_rule_id: number;
  message: string;
  fileshare_history_id: number;
  priority: boolean = false;
  auto_outgoing_rule_present: boolean = false;
  status_str: string;
  created_by_str: string;
  matter_name: string;
  matter_number: string;
  outgoing_checks: Array<OutgoingCheck> = [];
  outgoing_document_faxes: Array<OutgoingDocumentFax> = [];
  outgoing_documents: Array<OutgoingDocument> = [];
  outgoing_envelopes: Array<OutgoingEnvelope> = [];
  outgoing_labels: Array<OutgoingLabel> = [];
  fileshare_history_present: boolean = false;
  fileshare_history_downloads: any = [];
  fileshare_download_missing: boolean = false;
  failure_summary: any;
  last_errors: any;
  last_errors_array: Array<any> = [];
  last_errors_count: number = 0;
  last_errors_formatted: string;
  created_by_user_name: string;
  created_by_user_person_id: number;
  outgoing_checks_size: number;
  outgoing_document_faxes_size: number;
  outgoing_documents_size: number;
  outgoing_envelopes_size: number;
  outgoing_labels_size: number;
  continuing: boolean = false;
  finishing: boolean = false;
  releasing: boolean = false;
  taking: boolean = false;
  checked_out_by_contact_id: number;
  checked_out_by_user_name: string;
  checked_out: boolean = false;
  everything_sent: boolean = false;
  display_status: string;
  display_status_str: string;
  created_at_str: string;
  created_at_date: any;
  created_at_time: any;
}
